import {
  AWARD_AMOUNT_FIELDS,
  AwardAmounts,
  ExtractedAwardLetter,
} from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.types';

export type LetterChecks = Pick<
  ExtractedAwardLetter,
  'cost_of_attendance_stated' | 'loans_counted_as_aid' | 'parent_plus_listed_as_aid'
>;

export const amountsOf = (source: AwardAmounts): AwardAmounts =>
  Object.fromEntries(AWARD_AMOUNT_FIELDS.map((field) => [field, source[field]])) as AwardAmounts;

export const withExtracted = (current: AwardAmounts, extracted: AwardAmounts): AwardAmounts =>
  Object.fromEntries(
    AWARD_AMOUNT_FIELDS.map((field) => [field, extracted[field] ?? current[field]]),
  ) as AwardAmounts;

export const netCostOf = ({ cost_of_attendance, grants, scholarships }: AwardAmounts) =>
  cost_of_attendance === null ? null : cost_of_attendance - (grants ?? 0) - (scholarships ?? 0);

export const percentFromEstimate = (netCost: number | null, estimate: number | null) =>
  netCost === null || !estimate ? null : Math.round(((netCost - estimate) / estimate) * 100);

export const hasScholarships = ({ scholarships }: AwardAmounts) => (scholarships ?? 0) > 0;
